module.exports = __webpack_public_path__ + "static/localisation-bfc5e4ff5de8f3181947e9967c3a3db1.gif";